import * as React from 'react';
import { Reels } from 'features/DigitalMarketing/pages/Reels';

type ReelRoute = {
  subPath?: string;
  element: React.ReactElement;
};

export const REEL_ROUTES: ReelRoute[] = [
  { element: <Reels /> },
  { subPath: 'create', element: <Reels /> },
  { subPath: 'preview', element: <Reels /> },
  { subPath: 'preview/:id', element: <Reels /> },
];

export const REEL_SUB_ROUTES = REEL_ROUTES.map(route => ({
  path: route.subPath ? `reels/${route.subPath}` : 'reels',
  element: route.element,
}));
